import React, { useState, useEffect } from "react";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../firebase";
import Loader from "../components/Loader";

export default function Settings() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [settings, setSettings] = useState({
    otEnabled: true,
    workingHours: 8,
    otHourlyRate: 65,
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const docRef = doc(db, "settings", "global");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setSettings(docSnap.data());
        }
      } catch (error) {
        console.error("Error fetching settings:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  const handleSave = async () => {
    setSaving(true);
    try {
      await setDoc(doc(db, "settings", "global"), settings);
      alert("Settings saved successfully!");
    } catch (error) {
      console.error("Error saving settings:", error);
      alert("Failed to save settings.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <Loader />;

  return (
    <div className="card shadow-sm p-4 animate__animated animate__fadeIn">
      <h4 className="mb-4">Global Salary & OT Settings</h4>
      
      <div className="row g-4">
        <div className="col-md-6">
          <div className="card p-3 border-0 bg-light">
            <h5 className="mb-3">Overtime (OT) Configuration</h5>
            
            <div className="form-check form-switch mb-3">
              <input
                className="form-check-input"
                type="checkbox"
                id="otEnabled"
                checked={settings.otEnabled}
                onChange={(e) => setSettings({ ...settings, otEnabled: e.target.checked })}
              />
              <label className="form-check-label fw-bold" htmlFor="otEnabled">
                Enable OT Calculation
              </label>
              <div className="form-text">When disabled, OT hours and pay will be 0 for all employees.</div>
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold">Daily Working Hours (OT Threshold)</label>
              <div className="input-group">
                <input
                  type="number"
                  step="0.5"
                  className="form-control"
                  value={settings.workingHours}
                  onChange={(e) => setSettings({ ...settings, workingHours: Number(e.target.value) })}
                />
                <span className="input-group-text">hours</span>
              </div>
              <div className="form-text">Hours worked beyond this will be counted as OT.</div>
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold">OT Pay Rate (per hour)</label>
              <div className="input-group">
                <span className="input-group-text">₹</span>
                <input
                  type="number"
                  className="form-control"
                  value={settings.otHourlyRate}
                  onChange={(e) => setSettings({ ...settings, otHourlyRate: Number(e.target.value) })}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-4">
        <button
          className="btn btn-primary btn-lg px-5 shadow-sm"
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? (
            <>
              <span className="spinner-border spinner-border-sm me-2"></span>
              Saving...
            </>
          ) : (
            <>
              <i className="bi bi-save me-2"></i>
              Save Settings
            </>
          )}
        </button>
      </div>
    </div>
  );
}
